import approveShareObjectMutation from 'api/ShareObject/approveShareObjectMutation';
import useClient from 'api/client';
import { useAlert } from 'components/message/AlertContext';
import { useState } from 'react';

export default function useApproveShareObjectMutation(shareUri: string) {
    const [errorApproveShareObject, setErrorApproveShareObject] = useState<
        string | null
    >(null);
    const client = useClient();
    const { openAlert } = useAlert();

    const approveShareObject = async () => {
        const response = await client.mutate(
            approveShareObjectMutation(shareUri),
        );

        if (!response.errors) {
            openAlert({
                message: 'Approved shared request successful',
                severity: 'success',
            });

            return true;
        } else {
            const errorMsg = `Could not approve share request. ${response.errors[0]?.message}`;
            setErrorApproveShareObject(errorMsg);
            openAlert({
                message: errorMsg,
                severity: 'alert',
            });

            return false;
        }
    };

    return { errorApproveShareObject, approveShareObject };
}
